import EN from '../../../src/locales/en.default.json';
import FR from '../../../src/locales/fr.json';

const language = window.multilingual_settings?.currentLangIso;
const languageStore = language === 'fr' ? FR : EN;

const getByPath = (obj, path, separator=".") => {
  var properties = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev, curr) => prev && prev[curr], obj);
};

export const themeI18n = (path, replacements) => {
  let string = getByPath(languageStore, path);

  if (replacements) {
    for (const [key, value] of Object.entries(replacements)) {
      string = string.replace(`{{ ${key} }}` , value);
    }
  }

  return string;
}
